import ProductModel from '../../../models/product.model'

export default {
    SET_PRODUCTS(state, data) {
        state.products = data.map( product => {
            return  ProductModel.fromJson(product);
        });       
    },
    SET_KIT(state, data) {
        state.kit = data.map( product => {
            return  ProductModel.fromJson(product);
        })[0];       
    },
    LOADING (state) {
        state.loading++;
    },
    LOADED (state) {
        state.loading--;
    },
    
   /* FILTER_PRODUCTS (state, text) {
        state.filterText = text;
    },
    FILTER_COUNTRIES (state, countries) {
        state.filterCountries = countries;
    }*/
}